<template>
  <div class="text-right" @scroll="pageScroll">
    <div class="head" :class="ruleAwardCha ? 'mb0' : ''">
      <img class="head-img" src="../../assets/moveabout/titleBg.png" alt="">
      <!-- <div v-if="this.$i18n.locale == 'zh' || this.$i18n.locale == 'en' || this.$i18n.locale == 'tc'"><img
          class="title_img" src="../../assets/moveabout/title@3x.png" alt="#"></div>
      <div v-if="this.$i18n.locale == 'ar'"><img class="title_img" src="../../assets/moveabout/title3.png" alt="#"></div>
      <div v-if="this.$i18n.locale == 'tr'"><img class="title_img" src="../../assets/moveabout/title2.png" alt="#"></div> -->
      <!-- <div class="title_icon1" v-if="!ruleAwardCha"><img class="title_icon" src="../../assets/moveabout/gift@3x.png"
          alt="">
        <span class="title_txt">{{ $t('Weekly_Cp.gift') }}</span>
      </div> -->

      <div><img class="title_img" src="../../assets/moveabout/header.png" alt="#"></div>
      <div class="body_button2" v-if="ruleAwardCha">
        <div class="ruleAwardCss">
          <div class="rule" :class="activation == 1 ? 'activation_bg' : ''" @click="ruleAwardBtn(1)">{{
            $t('Weekly_Cp.rule') }}</div>
          <div class="rule" :class="activation == 2 ? 'activation_bg' : ''" @click="ruleAwardBtn(2)">{{
            $t('Weekly_Cp.reward') }}</div>
        </div>
        <div class="returncss" @click="returnBtn">{{
            $t('roomParty.back') }}</div>
      </div>
    </div>
    <div class="body" :class="ruleAwardCha ? 'body2' : ''">
      <div v-show="!ruleAwardCha">
        <div class="body_button">
          <div @click="ruleAward">{{ $t('Weekly_Cp.rule_reward') }}</div>
          <div class="bhbjbh" v-if="!statusCha" @click="lastWeek(1)">{{ $t('Weekly_Cp.last_week') }}</div>
          <div v-if="statusCha" @click="lastWeek(2)">{{ $t('Weekly_Cp.back') }}</div>

        </div>
        <div class="body_list">
          <div v-show="!statusCha" class="body_list_time">
            <div class="body_txt">{{ $t('Weekly_Cp.countdown') }}</div>
            <van-count-down :time="time">
              <template #default="timeData">

                <div>
                  <span class="block mr3">{{ String(timeData.days).split("").length == 1 ? 0 :
                    String(timeData.days).split("")[0] }}</span>
                  <span class="block">{{ String(timeData.days).split("").length == 1 ? String(timeData.days).split("")[0]
                    :
                    String(timeData.days).split("")[1] }}</span>
                  <div class="tac mt3 timetxt">{{ $t('Weekly_Cp.day') }}</div>
                </div>

                <div>
                  <span class="block mr3">{{ String(timeData.hours).split("").length == 1 ? 0 :
                    String(timeData.hours).split("")[0] }}</span>
                  <span class="block">{{ String(timeData.hours).split("").length == 1 ?
                    String(timeData.hours).split("")[0]
                    : String(timeData.hours).split("")[1] }}</span>
                  <div class="tac mt3 timetxt">{{ $t('Weekly_Cp.hour') }}</div>
                </div>

                <div>
                  <span class="block">{{ String(timeData.minutes).split("").length == 1 ? 0 :
                    String(timeData.minutes).split("")[0] }}</span>
                  <span class="block ml3">{{ String(timeData.minutes).split("").length == 1 ?
                    String(timeData.minutes).split("")[0] : String(timeData.minutes).split("")[1] }}</span>
                  <div class="tac mt3 timetxt">{{ $t('Weekly_Cp.minute') }}</div>
                </div>
                <div>
                  <span class="block">{{ String(timeData.seconds).split("").length == 1 ? 0 :
                    String(timeData.seconds).split("")[0] }}</span>
                  <span class="block ml3">{{ String(timeData.seconds).split("").length == 1 ?
                    String(timeData.seconds).split("")[0] : String(timeData.seconds).split("")[1] }}</span>
                  <div class="tac mt3 timetxt">{{ $t('Weekly_Cp.seconds') }}</div>
                </div>
              </template>
            </van-count-down>
            <div>
            </div>
          </div>
          <div v-if="statusCha" class="body_title">
            <img src="../../assets/moveabout/cutline.png" alt="">
            <span>{{ $t('Weekly_Cp.last_week_rank') }}</span>
            <img class="img-left" src="../../assets/moveabout/cutline.png" alt="">
          </div>
        </div>
        <div v-for="(item, index) in userInfoData.list" :key="index">
          <div class="user" v-if="item.top <= 3"
            :class="item.top == 1 ? 'n1frame' : '' || item.top == 2 ? 'n2frame' : '' || item.top == 3 ? 'n3frame' : ''">
            <div>
              <div class="user_head"
                :class="item.top == 1 ? 'golden' : '' || item.top == 2 ? 'tou' : '' || item.top == 3 ? 'sliver' : ''"
                @click="skipUserInfo(item, 1)">
                <img v-if="item.targetUser.headIcon" class="user_img" :src="item.targetUser.headIcon" alt="">
                <img v-else class="user_img" src="../../assets/moveabout/fj/mo.png" alt="">

              </div>
              <div class="user_name">{{ item.targetUser.nickname }}</div>
            </div>

            <div class="user_xin">
              <img class="user_xinimg1" src="../../assets/moveabout/heart@3x.png" alt="">
              <div class="user_xinimg2">{{ item.score.toLocaleString() }}</div>
            </div>
            <div>
              <div class="user_head"
                :class="item.top == 1 ? 'golden' : '' || item.top == 2 ? 'tou' : '' || item.top == 3 ? 'sliver' : ''"
                @click="skipUserInfo(item, 2)">
                <img v-if="item.user.headIcon" class="user_img" :src="item.user.headIcon" alt="">
                <img v-else class="user_img" src="../../assets/moveabout/fj/mo.png" alt="">

              </div>
              <div class="user_name">{{ item.user.nickname }}</div>
            </div>

          </div>
          <div class="user jcsa" v-if="item.top > 3">
            <div class="user_box" @click="skipUserInfo(item, 1)">

              <img v-if="item.targetUser.headIcon" class="user_img" :src="item.targetUser.headIcon" alt="">
              <img v-else class="user_img" src="../../assets/moveabout/fj/mo.png" alt="">


              <div class="user_name mt3">{{ item.targetUser.nickname }}</div>
            </div>
            <div class="lianxi_box">
              <img class="lianxi" src="../../assets/moveabout/hearbeat@3x.png" alt="">
            </div>

            <div class="user_box" @click="skipUserInfo(item, 2)">

              <img v-if="item.user.headIcon" class="user_img" :src="item.user.headIcon" alt="">
              <img v-else class="user_img" src="../../assets/moveabout/fj/mo.png" alt="">


              <div class="user_name mt3">{{ item.user.nickname }}</div>
            </div>

            <div class="user_xin2">
              <img class="user_xinimg1" src="../../assets/moveabout/heart@3x.png" alt="">
              <div class="user_xinimg2">{{ item.score.toLocaleString() }}</div>
            </div>
          </div>
        </div>
        <van-loading v-show="staChange" type="spinner" color="#fff" vertical/>
      </div>
      <div v-if="ruleAwardCha">


        <div v-if="activation == 1">
          <!-- 向上 start-->
          <div class="popup-wrap up-box">
            <div class="popup-con">
              <div class="popup_text" v-html="$t('Weekly_Cp.event_rule')">

              </div>

            </div>
          </div>
        </div>
        <div v-if="activation == 2" class="awardList">
          <div class="award_box">
            <img class="award_img" src="../../assets/moveabout/fj/lelele3x.png" alt="">
            <span class="award_txt">{{ $t('Weekly_Cp.top1') }}</span>
            <div class="award_icon">
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.7009')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.3days') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.7002')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.3days') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img style="height: 107px" src="../../assets/moveabout/2.png" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.3days') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img style="height: 107px" src="../../assets/moveabout/2.png" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.3days') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.diamonds')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.5diamonds') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.pocketcoins')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.5points') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.6010')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.15days') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.6004')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.15days') }}</span>
              </div>
            </div>
          </div>

          <div class="award_box">
            <img class="award_img" src="../../assets/moveabout/fj/lelele3x.png" alt="">
            <span class="award_txt1">{{ $t('Weekly_Cp.top2') }}</span>
            <div class="award_icon">
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.7016')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.3days') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.7003')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.3days') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img style="width:109px;height:67px;" src="../../assets/moveabout/1.png" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.3days') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img style="width:109px;height:67px;" src="../../assets/moveabout/1.png" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.3days') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.diamonds')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.3diamonds') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.pocketcoins')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.3points') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.6010')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.15days') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.6004')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.15days') }}</span>
              </div>
            </div>
          </div>


          <div class="award_box">
            <img class="award_img" src="../../assets/moveabout/fj/lelele3x.png" alt="">
            <span class="award_txt1">{{ $t('Weekly_Cp.top3') }}</span>
            <div class="award_icon">
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.7013')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.3days') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.7003')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.3days') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.diamonds')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.2diamonds') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.pocketcoins')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.2points') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.6010')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.7days') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.6004')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.7days') }}</span>
              </div>
            </div>
          </div>
          <div class="award_box">
            <img class="award_img" src="../../assets/moveabout/fj/lelele3x.png" alt="">
            <span class="award_txt1" style="top:-6%;">{{ $t('Weekly_Cp.top46') }}</span>
            <div class="award_icon">
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.6010')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.3days') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.6004')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.3days') }}</span>
              </div>
            </div>
          </div>
          <div class="award_box">
            <img class="award_img" src="../../assets/moveabout/fj/lelele3x.png" alt="">
            <span class="award_txt1" style="top:-6%;">{{ $t('Weekly_Cp.top710') }}</span>
            <div class="award_icon">
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.6010')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.1day') }}</span>
              </div>
              <div class="icon_left">
                <div class="icon_box">
                  <img :src="$t('Weekly_Cp.6004')" alt="">
                </div>
                <span class="txt">{{ $t('Weekly_Cp.1day') }}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>
  
  
<script>
import { Toast,CountDown, Loading } from "vant";
export default {
  name: "weeklyCp",
  components: {
    // HelloWorld
    VanCountDown: CountDown,
    VanLoading: Loading
  },
  data() {
    return {
      userInfo: [],
      userInfoData: {
        list:[],
        size:'',
        total:''
      },
      awardInfo: {
        endTime: '',
        startTime: '',
      },
      time: '',
      statusCha: false,
      ruleAwardCha: false,
      activation: 1,

      // token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOiJOREV5IiwieHl6IjoiWmpsalpEUTVZakpqT0daaU5HTmlNV0ZpTnpWbFkyWmlNell3WmpnNVlqVT0iLCJleHAiOjE5MDc3NDM3NDB9.irA-gNwNYSD9s6_BQH2nwiQU8Zprq5BS2nyHhqwIRYY',
      // uid: 412,
      // headers: [
      //   'Content-Type:' + 'application/json; charset=utf-8',
      //   'deviceId:' + 'f9cd49b2c8fb4cb1ab75ecfb360f89b5',
      //   'lang:' + 'zh_CN',
      //   'version:' + '2.0.2',
      //   'os:' + '1',
      //   'model:' + 'M2011K2C',
      //   'fid:' + '0',
      //   'buyUser:' + '1',
      // ],
      token: null,
      uid: null,
      headers: null,
      //排行榜类型
      rankType: 3,
      round: 1,
      type: 2,
      client: '',
      page: 0,
      size: 20,
      total:'',
      staChange:false,
      // 防止频繁请求
      notFast: true
    };
  },
  created() {
    this.$completes.complete("getUserInfo");
      window.getUserInfo = this.getUserInfo
      window['getUserInfo'] = (data) => {
      this.getUserInfo(data);
      }

    this.judgeClient()
    // this.getUserInfo();
  },
  mounted() {

  },
  methods: {

    //本周&上周
    lastWeek(code) {
      this.userInfoData.list = [];
      if (code == 1) {
        this.statusCha = true;
        this.round = 2;
      } else {
        this.statusCha = false;
        this.round = 1;
      }
      this.listData();
    },
    //规则&奖励
    ruleAward() {
      this.ruleAwardCha = true;

    },
    ruleAwardBtn(code) {
      if (code == 1) {
        this.activation = 1;
      } else {
        this.activation = 2;
      }
    },

    returnBtn() {
      this.ruleAwardCha = false;
      this.activation = 1;
    },

    skipUserInfo(item, idex) {
      let uid = '';
      if (idex == 1) {
        uid = item.targetUser.userId;
      } else {
        uid = item.user.userId;
      }
      if (this.client == 'iOS') {
        window["webkit"].messageHandlers['skipUserInfo'].postMessage(JSON.stringify(uid));
      } else if (this.client == 'Android') {
        nativeJs["skipUserInfo"](JSON.stringify(uid));
      }
    },


    judgeClient() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
        this.client = 'iOS';
      } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
        this.client = 'Android';
      } else {
        this.client = 'PC';
      }
      return this.client;
    },

    getUserInfo(data) {
      let that = this
      this.userInfo = JSON.parse(data);
      this.headers = [
          'Content-Type:' + 'application/json; charset=utf-8',
          'deviceId:' + JSON.parse(data).deviceId,
          'lang:' + JSON.parse(data).lang,
          'version:' + JSON.parse(data).version,
          'os:' + JSON.parse(data).os,
          'model:' + JSON.parse(data).model,
          'fid:' + JSON.parse(data).fid
      ]
      this.token = JSON.parse(data).token
      this.uid = JSON.parse(data).userId
      let langs = this.userInfo.lang.substring(0, 2)
      let lang = this.userInfo.lang
      // let langs = 'zh'
      // let lang = ''
      if (langs == 'zh') {
        if (lang == 'zh_TW' || lang == 'zh_HK') {
          this.$i18n.locale = 'tc'
        }
        else {
          this.$i18n.locale = 'zh'
        }
      }
      else if (langs == 'en') {
        this.$i18n.locale = 'en'
      }
      else if (langs == 'ar') {
        this.$i18n.locale = 'ar'
      }
      else if (langs == 'tr') {
        this.$i18n.locale = 'tr'
      }
      else if (langs == "fr") {
        this.$i18n.locale = "fr"
      } else if (langs == "id") {
        this.$i18n.locale = "id"
      } else if (langs == "ms") {
        this.$i18n.locale = "ms"
      } 
      else {
        this.$i18n.locale = 'en'
      }
      document.title = this.$t('Weekly_Cp.title')
      document.querySelector('html').setAttribute('lang', this.$i18n.locale);
      this.listData()
      this.awardData()
    },

    //分页
    pageScroll(e) {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = e.target.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight = e.target.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = e.target.scrollHeight;
      var num = scrollTop + windowHeight;
      var heightNum = Math.ceil(num)
      //滚动条到底部的条件
      if (heightNum == scrollHeight) {
        // if(this.userInfoData.list.length < this.total && this.userInfoData.size != this.userInfoData.total){
        //   this.size = this.size + 10
        //   this.listData()
        // }
        if(this.notFast){
            this.page++;
            this.listData();
        }

      }
    },


    listData() {
      this.notFast = false;
      this.staChange = true;
      let that = this
      let paramObjs = {
        option: 'get',
        host: this.$serviceIp + '/api/activity/rank/team/page?token=' + that.token + '&uid=' + that.uid + '&rankType=' + that.rankType + '&round=' + that.round + '&type=' + that.type + '&page=' + that.page + '&size=' + that.size,
        data: '',
        header: JSON.stringify(this.headers),
      };
      this.$server.curlExec(paramObjs).then((data) => {
        if (data.code == 200) {
          // this.userInfoData = data.data;
          // this.total = data.data.total;
          this.userInfoData.list.push(...data.data.list)
          this.userInfoData.size = data.data.size;
          this.userInfoData.total = data.data.total;
          this.staChange = false;
          if(data.data.size == data.data.length) {
              this.notFast = true;
          }
        }
        else {
          Toast(data.message || this.$t('transfer.error'))
        }

      })
    },


    awardData() {
      let that = this
      let paramObjs = {
        option: 'get',
        host: this.$serviceIp + '/api/activity/rank/index?token=' + that.token + '&uid=' + that.uid + '&rankType=' + that.rankType,
        data: '',
        header: JSON.stringify(this.headers),
      };
      this.$server.curlExec(paramObjs).then((data) => {
        if (data.code == 200) {
          this.awardInfo.endTime = Date.parse(data.data.endTime);
          this.awardInfo.startTime = Date.parse(new Date());
          this.time = Number(this.awardInfo.endTime) - Number(this.awardInfo.startTime);
        }
        else {
          Toast(data.message || this.$t('transfer.error'))
        }

      })

    },


  },




};

</script>
  
<style>
@import './weeklyCpCss.css';

* {
  margin: 0;
  padding: 0;
}
</style>